<template>
  <div class="tab-pane-inner">
    <div class="inspections-list form-inspection">
      <div class="inspection-title">
        <span>
          {{ $objectDenomination(customer) }} -
          {{ $t("COMMON.INSPECTIONS") }}
        </span>
      </div>
      <inspection-list-table
        :filterCustomer="customer.id"
        @onAddInspection="addInspection"
        @onViewInspection="viewInspection"
        @onEditInspection="editInspection"
        @onDeleteInspection="viewInspection"
      />
    </div>
  </div>
</template>

<script>
import {
  QUERY_ACTIONS_ADD,
  QUERY_ACTIONS_EDIT,
  QUERY_ACTIONS_VIEW,
} from "@/constants/common";
import InspectionListTable from "../../../InspectproModule/InspectionManagement/partials/InspectionListTable.vue";

export default {
  name: "customer-view-inspections",

  components: { InspectionListTable },

  props: ["customer"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {
    viewInspection(inspection) {
      this.$router.push({
        name: "List Inspections",
        query: { id: inspection.id, action: QUERY_ACTIONS_VIEW },
      });
    },
    editInspection(inspection) {
      this.$router.push({
        name: "List Inspections",
        query: { id: inspection.id, action: QUERY_ACTIONS_EDIT },
      });
    },
    addInspection() {
      this.$router.push({
        name: "List Inspections",
        query: {
          action: QUERY_ACTIONS_ADD,
          customer_id: this.customer.id,
        },
      });
    },
  },

  mounted() {},

  watch: {
    customer(customer) {},
  },
};
</script>
